import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import { srConfig, email } from '@config';
import sr from '@utils/sr';
import { Link } from 'gatsby';
import { usePrefersReducedMotion } from '@hooks';

const StyledContactSection = styled.section`
  max-width: 600px;
  margin: 0 auto 100px;
  text-align: center;

  @media (max-width: 768px) {
    margin: 0 auto 50px;
  }

  .overline {
    display: block;
    margin-bottom: 20px;
    color: var(--green);
    font-family: var(--font-mono);
    font-size: var(--fz-md);
    font-weight: 400;

    &:before {
      bottom: 0;
      font-size: var(--fz-sm);
    }

    &:after {
      display: none;
    }
  }

  .title {
    font-size: clamp(40px, 5vw, 60px);
    text-shadow: 2px 2px 0 #a3adcc;
    color: var(--white);
  }

  .email-link {
    ${({ theme }) => theme.mixins.bigButton};
    margin-top: 50px;
  }
`;

const Contact = () => {
  const revealContainer = useRef(null);
  const prefersReducedMotion = usePrefersReducedMotion();

  useEffect(() => {
    if (prefersReducedMotion) {
      return;
    }

    sr.reveal(revealContainer.current, srConfig());
  }, []);

  return (
    <StyledContactSection id="contact" ref={revealContainer}>
      <h2 className="numbered-heading overline"> What’s Next?</h2>

      <h2 className="title">Get In Touch</h2>

      <p>
        Whether it's a potential project or new opportunity, please shoot me an email. I'm always
        open to talk about fresh new ideas or to answer your questions.
      </p>

      <Link className="email-link" to="/message">
        Say Hello
      </Link>
      {/* 
      <a className="email-link" href={`mailto:${email}`}>
        Say Hello
      </a> */}
    </StyledContactSection>
  );
};

export default Contact;
